import React from 'react';
import { useTranslation } from 'react-i18next';

export const StatTiles = ({ tiles }) => {
    const { t } = useTranslation('reportPage');

    return (
        <nav className="stats" aria-label={t('page.keyNumbers')}>
            {tiles.map(tile => (
                <a className="stat" href={tile.href} key={tile.label}>
                    <span className={`stat-v${tile.small ? ' small' : ''}${tile.alert ? ' alert' : ''}`}>
                        {tile.value}
                    </span>
                    <span className="muted">{tile.label}</span>
                </a>
            ))}
        </nav>
    );
};
